// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {Proxy_type} from '../../../../hola/pub/ui/pro/cp/orders';

export const product_names = {
    [Proxy_type.ISP]: 'Global ISP',
    [Proxy_type.ISPPREM]: 'Search Engine ISP',
    [Proxy_type.DDC]: 'Dedicated Datacenter',
    [Proxy_type.SDC]: 'Shared Datacenter',
    [Proxy_type.RES]: 'Rotating Residential',
};

export const product_subtitles = {
    [Proxy_type.ISP]: 'IPs for stable access to any site, excluding'
    +' social media and search engines',
    [Proxy_type.ISPPREM]: 'US-based IPs for accessing search'
    +' engines and social media',
    [Proxy_type.DDC]: '',
    [Proxy_type.SDC]: '',
    [Proxy_type.RES]: '',
};
